import { api } from "api/api";
import { rejects } from "assert";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Veiculo from "model/gestao/frotas/Veiculo";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ItemEmprestimo from "model/patrimonio/ItemEmprestimo";
import { resolve } from "path";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ItemManutencaoVeiculoService implements BaseServiceCadastros<ItemEmprestimo> {
    
    pesquisar(page: Pageable,  filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/itemManutencaoVeiculo/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {reject(err.response);
                    console.error('Error status:', err.response?.status);
                    console.error('Error details:', err.response?.data);
                })
        });
    }

    consultar(id: number) {
        return new Promise<ItemEmprestimo>((resolve, reject): void => {
            api
                .get(`/itemEmprestimo/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(itemEmprestimo: ItemEmprestimo) {
        return new Promise<ItemEmprestimo>((resolve, reject): void => {
            api
                .post(`/itemEmprestimo/incluir`, JSON.stringify(itemEmprestimo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(itemEmprestimo: ItemEmprestimo) {
        return new Promise<ItemEmprestimo>((resolve, reject): void => {
            api
                .put(`/itemEmprestimo/editar`, JSON.stringify(itemEmprestimo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/itemEmprestimo/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    emprestar(itemEmprestimo: ItemEmprestimo) {
        return new Promise<ItemEmprestimo>((resolve, reject): void => {
            api
                .put(`/itemEmprestimo/emprestar`, JSON.stringify(itemEmprestimo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    devolvido(itemEmprestimo: ItemEmprestimo) {
        return new Promise<void>((resolve, reject): void => {
            api
                .put(`/itemEmprestimo/devolvido`, JSON.stringify(itemEmprestimo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    cancelar(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .put(`/itemEmprestimo/cancelar/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    pessoas() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/itemEmprestimo/pessoas`)
                .then((response) => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    veiculosDisponiveis() {
        return new Promise<Veiculo[]>((resolve, reject): void => {
            api
                .get(`/itemManutencaoVeiculo/veiculosDisponiveis`)
                .then((response) => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    getStatusLista(){
        return [{
                value: "CRIADO",
                label: "Criado"
            },
            {
                value: "EMPRESTADO",
                label: "Emprestado"
            },
            {
                value: "DEVOLVIDO",
                label: "Devolvido"
            },
            {
                value: "CANCELADO",
                label: "Cancelado"
            }]
    }

    getStatus(status: string): string | undefined {
        if(status==="GERADA") return "Gerada";
        if(status==="EM_ANDAMENTO") return "Em andamento";
        if(status==="FINALIZADA") return "Finalizada";
        return "";
    }

    getListaStatusFilter() {
        return [
            { label: "Criado", value: "C" },
            { label: "Emprestado", value: "E" },
            { label: "Devolvido", value: "D" },
            { label: "Cancelado", value: "X" }
        ]
    }

    getStatusManutencaoVeiculoFilter() {
        return [
            { label: 'Gerada', value: 'G' },
            { label: 'Finalizada', value: 'F' },

        ]
    }

    getTipoManutencaoVeiculoFilter() {
        return [
            { label: 'Preventiva', value: 'P' },
            { label: 'Corretiva', value: 'C' },
        ]
    }

    getTipo(tipo: string): string {
        if(tipo==="PREVENTIVA") return "Preventiva";
        if(tipo==="CORRETIVA") return "Corretiva";
        return "";
    }
}

export default ItemManutencaoVeiculoService;